import React, { useState, useEffect } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";

const ScrollButtons = () => {
  const [showTop, setShowTop] = useState(false);
  const [showBottom, setShowBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const innerHeight = window.innerHeight;
      const scrollHeight = document.documentElement.scrollHeight;

      setShowTop(scrollY > 200); // show top button after scrolling down 200px
      setShowBottom(scrollY + innerHeight < scrollHeight - 100); // show bottom button if not at bottom
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // initial check
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToBottom = () => {
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" });
  };

  return (
    <div className="fixed right-4 bottom-4 flex flex-col items-center space-y-2 z-50">
      {showTop && (
        <button
          onClick={scrollToTop}
          className="p-3 rounded-full bg-blue-400 text-white shadow-lg hover:bg-blue-500 transition-all duration-300"
          title="Scroll to Top"
        >
          <ChevronUp className="h-6 w-6" />
        </button>
      )}
      {showBottom && (
        <button
          onClick={scrollToBottom}
          className="p-3 rounded-full bg-purple-400 text-white shadow-lg hover:bg-purple-500 transition-all duration-300"
          title="Scroll to Bottom"
        >
          <ChevronDown className="h-6 w-6" />
        </button>
      )}
    </div>
  );
};

export default ScrollButtons;
